import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EcitationMuniStatusComponent } from './admin-pages/ecitation-muni-status/ecitation-muni-status.component';
import { EcitationStatusComponent } from './admin-pages/ecitation-status/ecitation-status.component';
import { EcitationErrorDocSearchComponent } from './ecitation-error-doc-search/ecitation-error-doc-search.component';
import { EcitationSearchComponent } from './ecitation-search/ecitation-search.component';
import { EcitationAgencyAnnualReportComponent } from './eCitationReports/ecitation-agency-annual-report/ecitation-agency-annual-report.component';
import { EcitationAgencySummaryReportComponent } from './eCitationReports/ecitation-agency-summary-report/ecitation-agency-summary-report.component';
import { EcitationAllReportComponent } from './eCitationReports/ecitation-all-report/ecitation-all-report.component';
import { EcitationDayofweekUsageReportComponent } from './eCitationReports/ecitation-dayofweek-usage-report/ecitation-dayofweek-usage-report.component';
import { EcitationDeliveryAnnualReportComponent } from './eCitationReports/ecitation-delivery-annual-report/ecitation-delivery-annual-report.component';
import { EcitationDeliverySummaryReportComponent } from './eCitationReports/ecitation-delivery-summary-report/ecitation-delivery-summary-report.component';
import { EcitationHourlyUsageReportComponent } from './eCitationReports/ecitation-hourly-usage-report/ecitation-hourly-usage-report.component';
import { PublicCitationSearchComponent } from './public-citation-search/public-citation-search.component';
import { EcitationCourtComponent } from './admin-pages/ecitation-court/ecitation-court.component';
import { EcitationVendorComponent } from './admin-pages/ecitation-vendor/ecitation-vendor.component';
import { EcitationLoginComponent } from './ecitation-login/ecitation-login.component';
import { EcitationUserComponent } from './admin-pages/ecitation-user/ecitation-user.component';
import { AuthGuard } from 'src/services/auth.guard';

const routes: Routes = [
  
  {
    path: 'secure/login',
    component: EcitationLoginComponent,
  },
  {
    path: 'secure',
   redirectTo:'secure/login',pathMatch:'full'
  },
  {
    path: '',  component: PublicCitationSearchComponent,
  },
  { 
    path: 'secure/ecitationSearch', 
    component: EcitationSearchComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/errorDocSearch',
    component: EcitationErrorDocSearchComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/allReport",
    component: EcitationAllReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/deliverysummaryReport",
    component: EcitationDeliverySummaryReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/deliveryAnnualReport",
    component: EcitationDeliveryAnnualReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/hourlyUsageReport",
    component: EcitationHourlyUsageReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/dayofweekUsageReport",
    component: EcitationDayofweekUsageReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/agencyAnnualReport",
    component: EcitationAgencyAnnualReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: "secure/agencySummaryReport",
    component: EcitationAgencySummaryReportComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/publicCitationSearch',
    component: PublicCitationSearchComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/ecitationStatus',
    component: EcitationStatusComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/ecitationMuniStatus',
    component: EcitationMuniStatusComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/ecitationUsers',
    component: EcitationUserComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/ecitationCourt',
    component:EcitationCourtComponent,
    canActivate:[AuthGuard] 
    
  },
  {
    path: 'secure/ecitationVendor',
    component:EcitationVendorComponent,
    canActivate:[AuthGuard] 
    
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
